import type { Template } from "@/types";

export const PO_01_H1_V0: Template[] = [
    {
        id: "po-01-h1v0-01",
        name: "PO 01 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 163, y: 153, width: 925, height: 587, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-02",
        name: "PO 02 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 71, y: 95, width: 1111, height: 705, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-03",
        name: "PO 03 - H1V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 95, width: 1252, height: 705, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-04",
        name: "PO 04 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 161, y: 0, width: 930, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-05",
        name: "PO 05 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 61, y: 63, width: 1129, height: 767, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-06",
        name: "PO 06 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1252, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-07",
        name: "PO 07 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 626, y: 224, width: 626, height: 445, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-08",
        name: "PO 08 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 679, y: 263, width: 519, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-09",
        name: "PO 09 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 224, width: 626, height: 445, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-10",
        name: "PO 10 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 54, y: 263, width: 519, height: 369, rotation: 0, imageRotation: 0 }
        ],
    }
];